import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { run } from "./labels";

const F = ({ label, children }) => <div className="space-y-1"><Label className="text-xs">{label}</Label>{children}</div>;

export const MisuraDialog = ({ rigaId, initial, onClose, onSaved }) => {
  const [subs, setSubs] = useState([]);
  const [f, setF] = useState({ data: initial?.data || new Date().toISOString().slice(0, 10), quantita: initial?.quantita || "",
    subappaltatore_id: initial?.subappaltatore_id || "", esecutore_nome: initial && !initial.subappaltatore_id ? initial.esecutore : "", note: initial?.note || "" });
  const set = (k) => (e) => setF((o) => ({ ...o, [k]: e.target.value }));
  useEffect(() => { api.get("/anagrafiche/subappaltatori").then((r) => setSubs(r.data)); }, []);
  const salva = async () => {
    const body = { data: f.data, quantita: f.quantita, subappaltatore_id: f.subappaltatore_id || null, esecutore_nome: f.subappaltatore_id ? null : f.esecutore_nome || null, note: f.note || null };
    const r = await run(() => (initial ? api.patch(`/misure/${initial.id}`, body) : api.post(`/righe/${rigaId}/misure`, body)), "Misura salvata");
    if (r) onSaved();
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="misura-dialog">
        <DialogHeader>
          <DialogTitle>{initial ? "Modifica misura" : "Nuova misura"}</DialogTitle>
          <DialogDescription>La misura nasce da verificare. Se la modifichi dopo la verifica, la verifica viene rimossa.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <F label="Data"><Input type="date" value={f.data} onChange={set("data")} data-testid="misura-data" /></F>
          <F label="Quantità"><Input type="number" min="0" step="any" value={f.quantita} onChange={set("quantita")} data-testid="misura-quantita" /></F>
          <div className="col-span-2"><F label="Eseguita da"><select className="w-full border rounded-md h-9 px-2 text-sm" value={f.subappaltatore_id} onChange={set("subappaltatore_id")} data-testid="misura-subappaltatore">
            <option value="">Impresa (nessun subappaltatore)</option>{subs.map((s) => <option key={s.id} value={s.id}>{s.nome}</option>)}</select></F></div>
          {!f.subappaltatore_id && <div className="col-span-2"><F label="Squadra / operaio (facoltativo)"><Input value={f.esecutore_nome} onChange={set("esecutore_nome")} data-testid="misura-esecutore" /></F></div>}
          <div className="col-span-2"><F label="Note / posizione"><Input value={f.note} onChange={set("note")} data-testid="misura-note" /></F></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="misura-annulla">Annulla</Button>
          <Button onClick={salva} disabled={!f.data || !(Number(f.quantita) > 0)} data-testid="misura-salva">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
